import DescriptionIcon from '@material-ui/icons/Description';

import List from './List';

export default {
  list: List,
  icon: DescriptionIcon,
};
